import { Columns } from '@repo/types-client';

import { useScreenSize } from './use-screen-size';

interface UseGridColumnsOptions {
  columnConfig: Columns | undefined;
}

/**
 * Custom hook to determine the number of grid columns based on screen size.
 * @function useGridColumns
 * @param {UseGridColumnsOptions} options - The options for configuring grid columns.
 * @param {Columns} options.columnConfig - The column configuration for different screen sizes.
 * @returns {object} An object containing the number of columns.
 */
export const useGridColumns = ({ columnConfig }: UseGridColumnsOptions) => {
  const { isMobile, isTablet, isDesktop, isUltrawide } = useScreenSize();

  let columns: number = 0;

  if (isMobile) {
    columns = columnConfig?.mobile || 3;
  } else if (isTablet) {
    columns = columnConfig?.tablet || 3;
  } else if (isDesktop) {
    columns = columnConfig?.desktop || 4;
  } else if (isUltrawide) {
    columns = columnConfig?.ultrawide || 4;
  }

  return { columns };
};
